import React, { useEffect,useRef, useState } from "react";
import { IconButton, Container, Box } from "@mui/material";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import DeleteIcon from "@mui/icons-material/Delete";
import apiClient from "../api/apiClient";
import CompTooltip from "../components/ET";
import { uD } from '../context/DC';

const UploadBankUob = () => {
  const [files, setFiles] = useState([]);
  const [fileE, setFileE] = useState({});
  const [hasErrorFiles, setHasErrorFiles] = useState(false);
  const fileInputRef = useRef(null);
  const allowedFileTypes = [".csv"];
  const [allowedKeywords, setAllowedKeywords] = useState([]);
  const [allowedPrefixes, setAllowedPrefixes] = useState([]); 
  const { mG } = uD();

  const fetchConfigData = async () => {
    try {
      const response = await apiClient.get("/api/config-upload-id", {
        headers: {
          'x-screen': 'bank-uob',  
        },
      });

      if (response.data["0"]) {
        const keywords = response.data["0"].keyword ? response.data["0"].keyword.split(",").map(item => item.trim()) : [];
        const prefixes = response.data["0"].prefix ? response.data["0"].prefix.split(",").map(item => item.trim()) : [];
        setAllowedKeywords(keywords || []);
        setAllowedPrefixes(prefixes|| []);
      }
    } catch (error) {
      let errMsg = "";
      if (error?.response?.data) {errMsg = error.response.data.error ||error.response.data.message ||JSON.stringify(error.response.data);
      } else if (error?.message) {errMsg = error.message;}
      await mG({t: "Failed",tc: "#e40000",m: errMsg || "Please contact aiscimer team.",bt: "Close",btc: "white",bc: "#ff1616",bch: "#d40000",}); 
    }
  };

  useEffect(() => {
    fetchConfigData();
  }, []);

  const validateFileType = (file) => {
    return allowedFileTypes.some((type) => file.name.endsWith(type));
  };

  const validateFilePrefix = (fileName) => {
    return allowedPrefixes.some((prefix) => fileName.startsWith(prefix));
  };

  const validateFileKeyword = (fileName) => {
    return allowedKeywords.some((keyword) => fileName.toLowerCase().includes(keyword));
  };

  const handleDrop = async (event) => {
    event.preventDefault();
    const droppedFiles = Array.from(event.dataTransfer.files);
    if (hasErrorFiles) {
      setFiles(droppedFiles); 
      setFileE({});            
      setHasErrorFiles(false); 
      event.dataTransfer.clearData();
      return;
    }

    const validFiles = droppedFiles.filter((file) => {
      const isValidType = validateFileType(file);
      const isValidPrefix = allowedPrefixes.length === 0 ? true : validateFilePrefix(file.name);
      const isValidKeyword = allowedKeywords.length === 0 ? true : validateFileKeyword(file.name);
      return isValidType && isValidPrefix && isValidKeyword;
    });

    if (validFiles.length !== droppedFiles.length) {
      await mG({t: "Failed",tc: "#e40000",m: "ชื่อไฟล์ไม่ตรงกับค่า prefix หรือ keyword ที่ทำการเช็ค กรุณาเลือกไฟล์ใหม่",bt: "Close",btc: "white",bc: "#ff1616",bch: "#d40000",}); 
    }

    setFiles((prev) => {
      const existingFileNames = new Set(prev.map((f) => f.name));
      const nonDuplicateFiles = validFiles.filter((f) => !existingFileNames.has(f.name));
      return [...prev, ...nonDuplicateFiles];
    });

    event.dataTransfer.clearData();
  };

  const handleClick = () => {
    fileInputRef.current.click();
  };

  const handleFileSelect = async (event) => {
    const selectedFiles = Array.from(event.target.files);

    const validFiles = selectedFiles.filter((file) => {
      const isValidType = validateFileType(file);
      const isValidPrefix = allowedPrefixes.length === 0 ? true : validateFilePrefix(file.name); 
      const isValidKeyword = allowedKeywords.length === 0 ? true : validateFileKeyword(file.name);
      return isValidType && isValidPrefix && isValidKeyword;
    });

    if (validFiles.length !== selectedFiles.length) {
      await mG({t: "Failed",tc: "#e40000",m: "ชื่อไฟล์ไม่ตรงกับค่า prefix หรือ keyword ที่ทำการเช็ค กรุณาเลือกไฟล์ใหม่",bt: "Close",btc: "white",bc: "#ff1616",bch: "#d40000",}); 
    }

    if (hasErrorFiles) {
      setFiles(validFiles);
      setFileE({});
      setHasErrorFiles(false);
    } else {
      setFiles((prevFiles) => {
        const existingFileNames = new Set(prevFiles.map((f) => f.name));
        const nonDuplicateFiles = validFiles.filter((f) => !existingFileNames.has(f.name));
        return [...prevFiles, ...nonDuplicateFiles];
      });
    }

    event.target.value = null;
  };

  const handleRemoveFile = (index) => {
    const fileToRemove = files[index];

    setFileE((prevFileE) => {
      const newFileE = { ...prevFileE };
      delete newFileE[fileToRemove.name];
      return newFileE;
    });

    setFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
  };

  const uploadFiles = async () => {
    if (files.length === 0) {
      await mG({t: "Failed",tc: "#e40000",m: "กรุณาเลือกไฟล์เพื่ออัพโหลด",bt: "Close",btc: "white",bc: "#ff1616",bch: "#d40000",}); 
      return;
    }

    const formData = new FormData();
    const fileData = []; // เก็บข้อมูลไฟล์ทั้งหมดในอาร์เรย์

    // เพิ่มไฟล์และข้อมูลเพิ่มเติม (เช่น ชื่อไฟล์) ใน FormData
    files.forEach((file) => {
        formData.append("files", file);
        fileData.push({ fileName: file.name, fileType: file.type });
    });

    formData.append("fileData", JSON.stringify(fileData));
    formData.append("fileCategory", "bank-uob");
    const token = localStorage.getItem("token");
    try {
      const r = await apiClient.post(
        "/api-file/file-upload",  
        formData
        , {
          headers: {
            "Content-Type": "multipart/form-data",
            "Authorization": `Bearer ${token}` 
          },
        }
      );

      if (r.data.s === '0') {
        setFiles([]);
        setFileE({});
        setHasErrorFiles(false);
        await mG({t: "Complete",tc: "#519a39",m: r.data.m,bt: "OK",btc: "white",bc: "#66bb49",bch: "#3f762c",}); 
      } else if (r.data.s === '10') {
        const rd = r.data.d || [];
        const e = {};
        const f = [];
        rd.forEach(result => {
          if (result?.st !== "success") {
            f.push(result.fn);
            e[result.fn] = result?.rs || "เกิดข้อผิดพลาดที่ไม่ทราบสาเหตุ";
          }
        });

        setFiles(prev => prev.filter(file => f.includes(file.name)));
        setFileE(e);
        setHasErrorFiles(true); 
        await mG({t: "Failed",tc: "#e40000",m: r.data.m,bt: "Close",btc: "white",bc: "#ff1616",bch: "#d40000",}); 
      } else {
        setFileE(r.data.m);
        setHasErrorFiles(true); 
        await mG({t: "Failed",tc: "#e40000",m: `${r.data.m} ${r.data.e}`|| "Failed to upload files.",bt: "Close",btc: "white",bc: "#ff1616",bch: "#d40000",});
      }

    } catch (error) {
      let errMsg = "";
      if (error?.response?.data) {errMsg = error.response.data.error ||error.response.data.message ||JSON.stringify(error.response.data);
      } else if (error?.message) {errMsg = error.message;}  
      await mG({t: "Failed",tc: "#e40000",m: errMsg || "Please contact aiscimer team.",bt: "Close",btc: "white",bc: "#ff1616",bch: "#d40000",}); 
    }

  };

  return (
    <Container component="main" maxWidth="96%" sx={{marginTop: "40px",border: "0px solid #e0e0e0",boxSizing: "border-box",}}>
      <Box sx={{ width: '100%',display: "flex",flexDirection: "column", marginLeft:0, marginBottom:0, boxShadow: "none",marginTop: "0px",border: "0px solid #e0e0e0" ,boxSizing: "border-box",
        backgroundColor: "background.paper",
      }}>
        <Box sx={{ borderRadius: 0,boxSizing: "border-box",marginBottom:0, boxShadow: "none",marginTop: "0px",
          textAlign: "center",
          verticalAlign: "middle",
          padding:1,
          backgroundColor: "#f5f5f5",
          fontSize: "calc(14px + 0.5vw)",
          fontWeight: "bold",
          color: "#333",
        }}>
          อัพโหลดข้อมูลธนาคาร - ธนาคารยูโอบี
        </Box>

        <Box sx={{ borderRadius: 0,boxSizing: "border-box",marginBottom:0, boxShadow: "none",marginTop: "0px",
                  textAlign: "center",
                  verticalAlign: "middle",
                  padding:1,
                  // backgroundColor: "#f5f5f5",
                  fontSize: "calc(14px - 0.01vw)",
                  fontWeight: "bold",
                  color: "#333",
                }}>
                  <div>1.ประเภทบัญชี: เงินฝากกระแสรายวัน เลขที่บัญชี: 961-3-63250-2 ประเภทไฟล์: CSV</div>
                  <div>2.ประเภทบัญชี: เงินฝากออมทรัพย์ เลขที่บัญชี: 961-1-66575-6 ประเภทไฟล์: CSV</div>
        </Box>

        <Box sx={{  marginBottom:"4px", boxShadow: "none",marginTop: "4px",border: "1px solid #e0e0e0" ,boxSizing: "border-box",
          borderRadius: 0,
        }}>
          <div
            onClick={handleClick}
            onDrop={handleDrop}
            onDragOver={(e) => e.preventDefault()}
            onDragEnter={(e) => e.preventDefault()}  
            style={{
              border: "2px dashed #ccc",
              padding: "30px",
              marginTop: "1px",
              marginBottom: "1px",
              textAlign: "center",
              cursor: "pointer",
              fontSize: "calc(14px - 0.01vw)",
            }}
          >
            กรุณาคลิกภายในกรอบเพื่อเลือกไฟล์สำหรับการอัพโหลดหรือลากไฟล์ที่ต้องการอัพโหลดมาวางไว้ในกรอบ
            <input
              type="file"
              multiple
              ref={fileInputRef}
              onChange={handleFileSelect}
              style={{ display: "none" }}
              accept=".csv" // ระบุชนิดไฟล์ที่อนุญาต
            />
          </div>
        </Box>
        
        {files.length > 0 && (
        
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 300 }} size="small" aria-label="a dense table">
            <TableHead sx={{ backgroundColor: '#f5f5f5' }}>
                <TableRow>
                  <TableCell align="center">ลำดับ</TableCell>
                  <TableCell align="center">ชื่อไฟล์</TableCell>
                  <TableCell align="center">สถานะไฟล์</TableCell>
                  <TableCell align="center">ลบ</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {files.map((file, index) => (
                  <TableRow
                    key={index}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                  >
                    <TableCell align="center" component="th" scope="row">
                      {index+1}
                    </TableCell>
                    <TableCell align="left">{file.name}</TableCell>
                    <TableCell align="center">
                      {fileE[file.name] ? (
                        <CompTooltip message={fileE[file.name]} />
                      ) : (
                        "📄"
                      )}
                    </TableCell>                    
                    <TableCell align="center">
                    <IconButton onClick={() => handleRemoveFile(index)} color="error">
                        <DeleteIcon />
                    </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
        
        {files.length > 0 && Object.keys(fileE).length === 0 && (
          <Box sx={{  marginBottom:0, boxShadow: "none",marginTop: "4px" ,boxSizing: "border-box",
            borderRadius: 0,
            padding: "4px 4px",
            textAlign: "center",
            verticalAlign: "middle",
          }}>
            <button
              onClick={uploadFiles}
              style={{
                padding: "8px 15px",
                background: "#0061d4",
                color: "white",
                border: "none",
                cursor: "pointer",
                fontSize: "calc(8px + 0.5vw)",
              }}
            >
              อัพโหลดไฟล์
            </button>
          </Box>
        )}

      </Box>

    </Container>
  );
};

export default UploadBankUob;